import React from 'react'
import './TestimonialRow.scss'
import PropTypes from 'prop-types'
import PageComponent from './PageComponent'
import ReactMarkdown from 'react-markdown'
import {GatsbyImage} from 'gatsby-plugin-image'
import cmsMarkdownRenderers from '../../helpers/markdown/cmsMarkdownRenderers'

const TestimonialRow = ({content, imageData, imageAlt, author}) => {
    return (
        <PageComponent backgroundColor="lightgray">
            <div className={'page__testimonial-row'}>
                <span className={'page__testimonial-row__author'}>
                    {imageData && (
                        <GatsbyImage image={imageData} alt={imageAlt} className={'page__testimonial-row__image'} />
                    )}
                </span>
                <span className={'page__testimonial-row__content'}>
                    <ReactMarkdown source={content} renderers={cmsMarkdownRenderers} />
                    <span className={'page__testimonial-row__signature'}>
                        <ReactMarkdown source={author} escapeHtml={false} renderers={cmsMarkdownRenderers} />
                    </span>
                </span>
            </div>
        </PageComponent>
    )
}

TestimonialRow.propTypes = {
    id: PropTypes.string,
    content: PropTypes.string,
    author: PropTypes.string,
    imageData: PropTypes.object,
    imageAlt: PropTypes.string,
}

TestimonialRow.defaultProps = {
    content: '',
    author: '',
    imageAlt: '',
}

export default TestimonialRow
